(function () {
  var announcementKey = 'cuAnnouncementDismissed'
  var favoritesKey = 'cuFavorites'
  var transientFavorites = []

  function wasDismissed() {
    try {
      return window.sessionStorage.getItem(announcementKey) === 'true'
    } catch (error) {
      return false
    }
  }

  function rememberDismissal() {
    try {
      window.sessionStorage.setItem(announcementKey, 'true')
    } catch (error) {
      // The announcement can still be closed when storage is unavailable.
    }
  }

  function hideAnnouncement(announcement) {
    var toolbarSection = announcement.closest('.toolbar-section')

    if (toolbarSection) {
      toolbarSection.hidden = true
    } else {
      announcement.hidden = true
    }

    window.dispatchEvent(new Event('resize'))
  }

  function initializeAnnouncement() {
    if (!wasDismissed()) {
      return
    }

    document.querySelectorAll('[data-cu-announcement]').forEach(hideAnnouncement)
  }

  function selectMegaCategory(menu, button) {
    var target = button.getAttribute('data-cu-mega-category')
    var categoryButtons = menu.querySelectorAll('[data-cu-mega-category]')
    var panels = menu.querySelectorAll('[data-cu-mega-panel]')

    categoryButtons.forEach(function (categoryButton) {
      var isActive = categoryButton === button

      categoryButton.classList.toggle('is-active', isActive)
      categoryButton.setAttribute('aria-selected', isActive ? 'true' : 'false')
    })

    panels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-cu-mega-panel') === target

      panel.hidden = !isActive
      panel.classList.toggle('is-active', isActive)
    })
  }

  function selectMegaTab(menu, button) {
    var target = button.getAttribute('data-cu-mega-tab')
    var tabButtons = menu.querySelectorAll('[data-cu-mega-tab]')
    var tabGroups = menu.querySelectorAll('[data-cu-mega-tab-group]')

    tabButtons.forEach(function (tabButton) {
      var isActive = tabButton === button

      tabButton.classList.toggle('is-active', isActive)
      tabButton.setAttribute('aria-selected', isActive ? 'true' : 'false')
      tabButton.setAttribute('tabindex', isActive ? '0' : '-1')
    })

    tabGroups.forEach(function (group) {
      group.hidden = group.getAttribute('data-cu-mega-tab-group') !== target
    })

    var activeGroup = menu.querySelector('[data-cu-mega-tab-group="' + target + '"]')
    var firstCategory = activeGroup && activeGroup.querySelector('[data-cu-mega-category]')

    if (firstCategory) {
      selectMegaCategory(menu, firstCategory)
    }
  }

  function initializeMegaMenus(scope) {
    var root = scope || document

    root.querySelectorAll('[data-cu-mega]').forEach(function (menu) {
      if (menu.dataset.cuMegaReady === 'true') {
        return
      }

      menu.dataset.cuMegaReady = 'true'

      menu.querySelectorAll('[data-cu-mega-tab]').forEach(function (button) {
        button.addEventListener('click', function () {
          selectMegaTab(menu, button)
        })
      })

      menu.querySelectorAll('[data-cu-mega-category]').forEach(function (button) {
        button.addEventListener('click', function () {
          selectMegaCategory(menu, button)
        })

        button.addEventListener('pointerenter', function () {
          if (window.matchMedia('(min-width: 769px)').matches) {
            selectMegaCategory(menu, button)
          }
        })
      })
    })

    root.querySelectorAll('.cu-menu-details').forEach(function (details) {
      if (details.dataset.cuDetailsReady === 'true') {
        return
      }

      details.dataset.cuDetailsReady = 'true'
      details.addEventListener('toggle', function () {
        if (!details.open) {
          return
        }

        document.querySelectorAll('.cu-menu-details[open]').forEach(function (otherDetails) {
          if (otherDetails !== details) {
            otherDetails.open = false
          }
        })
      })
    })
  }

  function selectHeaderSearchTab(button) {
    var searchPanel = button.closest('.site-header__search')

    if (!searchPanel) {
      return
    }

    searchPanel.querySelectorAll('[data-cu-header-search-tab]').forEach(function (tabButton) {
      var isActive = tabButton === button

      tabButton.classList.toggle('is-active', isActive)
      tabButton.setAttribute('aria-selected', isActive ? 'true' : 'false')
      tabButton.setAttribute('tabindex', isActive ? '0' : '-1')
    })

    var searchInput = searchPanel.querySelector('input[type="search"]')

    if (searchInput) {
      searchInput.setAttribute('placeholder', button.getAttribute('data-placeholder'))
      searchInput.focus()
    }
  }

  function initializeHeaderSearchTabs(scope) {
    var root = scope || document

    root.querySelectorAll('[data-cu-header-search-tab]').forEach(function (button) {
      if (button.dataset.cuHeaderSearchReady === 'true') {
        return
      }

      button.dataset.cuHeaderSearchReady = 'true'
      button.addEventListener('click', function () {
        selectHeaderSearchTab(button)
      })
    })

    root.querySelectorAll('.site-header__search').forEach(function (searchPanel) {
      var activeTab = searchPanel.querySelector('[data-cu-header-search-tab].is-active')
      var searchInput = searchPanel.querySelector('input[type="search"]')

      if (activeTab && searchInput) {
        searchInput.setAttribute('placeholder', activeTab.getAttribute('data-placeholder'))
      }
    })
  }

  function selectProcessStep(showcase, button) {
    var target = button.getAttribute('data-cu-process-step')

    showcase.querySelectorAll('[data-cu-process-step]').forEach(function (stepButton) {
      var isActive = stepButton === button

      stepButton.classList.toggle('is-active', isActive)
      stepButton.setAttribute('aria-selected', isActive ? 'true' : 'false')
      stepButton.setAttribute('tabindex', isActive ? '0' : '-1')
    })

    showcase.querySelectorAll('[data-cu-process-panel]').forEach(function (panel) {
      var isActive = panel.getAttribute('data-cu-process-panel') === target

      panel.hidden = !isActive
      panel.classList.toggle('is-active', isActive)
    })

    showcase.dispatchEvent(new CustomEvent('cu:process:change'))
  }

  function initializeProcessAutoRotation(showcase) {
    var buttons = Array.prototype.slice.call(showcase.querySelectorAll('[data-cu-process-step]'))
    var autoRotate = showcase.getAttribute('data-cu-process-auto') === 'true'
    var interval = parseInt(showcase.getAttribute('data-cu-process-interval'), 10) || 5000
    var timer = null
    var isFocusPaused = false
    var isInView = typeof window.IntersectionObserver === 'undefined'

    if (
      !autoRotate ||
      buttons.length < 2 ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      return
    }

    function clearRotation() {
      if (timer) {
        window.clearTimeout(timer)
        timer = null
      }
    }

    function scheduleRotation() {
      clearRotation()

      if (
        !showcase.isConnected ||
        document.hidden ||
        !isInView ||
        isFocusPaused
      ) {
        return
      }

      timer = window.setTimeout(function () {
        var activeIndex = buttons.findIndex(function (button) {
          return button.getAttribute('aria-selected') === 'true'
        })
        var nextButton = buttons[(activeIndex + 1) % buttons.length]

        selectProcessStep(showcase, nextButton)
      }, interval)
    }

    showcase.addEventListener('cu:process:change', scheduleRotation)
    showcase.addEventListener('focusin', function () {
      isFocusPaused = true
      clearRotation()
    })
    showcase.addEventListener('focusout', function (event) {
      if (event.relatedTarget && showcase.contains(event.relatedTarget)) {
        return
      }

      isFocusPaused = false
      scheduleRotation()
    })
    document.addEventListener('visibilitychange', scheduleRotation)

    if (typeof window.IntersectionObserver !== 'undefined') {
      var observer = new IntersectionObserver(
        function (entries) {
          isInView = entries[0].isIntersecting
          scheduleRotation()
        },
        { threshold: 0.35 }
      )

      observer.observe(showcase)
    } else {
      scheduleRotation()
    }
  }

  function initializeProcessShowcases(scope) {
    var root = scope || document

    root.querySelectorAll('[data-cu-process]').forEach(function (showcase) {
      if (showcase.dataset.cuProcessReady === 'true') {
        return
      }

      showcase.dataset.cuProcessReady = 'true'

      showcase.querySelectorAll('[data-cu-process-step]').forEach(function (button) {
        button.addEventListener('click', function () {
          selectProcessStep(showcase, button)
        })
      })

      showcase.querySelectorAll('[data-cu-process-next]').forEach(function (button) {
        button.addEventListener('click', function () {
          var nextStep = showcase.querySelector(
            '[data-cu-process-step="' + button.getAttribute('data-cu-process-next') + '"]'
          )

          if (nextStep) {
            selectProcessStep(showcase, nextStep)
          }
        })
      })

      initializeProcessAutoRotation(showcase)
    })
  }

  function normalizeFavoritePrice(value) {
    var decoder = document.createElement('textarea')

    decoder.innerHTML = String(value || '')

    return decoder.value
      .replace(/<[^>]*>/g, '')
      .replace(/\s+/g, ' ')
      .trim()
  }

  function readFavorites() {
    try {
      var storedValue = window.localStorage.getItem(favoritesKey)

      if (storedValue === null) {
        return transientFavorites
      }

      var storedFavorites = JSON.parse(storedValue)

      if (!Array.isArray(storedFavorites)) {
        return []
      }

      transientFavorites = storedFavorites
        .filter(function (item) {
          return item && item.id && item.url && item.title
        })
        .slice(0, 50)
        .map(function (item) {
          item.price = normalizeFavoritePrice(item.price)
          return item
        })
      return transientFavorites
    } catch (error) {
      return transientFavorites
    }
  }

  function writeFavorites(favorites) {
    transientFavorites = favorites.slice(0, 50)

    try {
      window.localStorage.setItem(favoritesKey, JSON.stringify(transientFavorites))
    } catch (error) {
      // Favorites continue to work for the current page when storage is unavailable.
    }
  }

  function productFromFavoriteButton(button) {
    return {
      id: button.getAttribute('data-cu-favorite-id'),
      url: button.getAttribute('data-cu-favorite-url'),
      title: button.getAttribute('data-cu-favorite-title'),
      image: button.getAttribute('data-cu-favorite-image'),
      price: normalizeFavoritePrice(button.getAttribute('data-cu-favorite-price'))
    }
  }

  function createFavoritePreviewItem(item) {
    var row = document.createElement('div')
    var link = document.createElement('a')
    var imageWrap = document.createElement('span')
    var details = document.createElement('span')
    var title = document.createElement('strong')
    var price = document.createElement('small')
    var removeButton = document.createElement('button')

    row.className = 'cu-mini-favorites__row'
    link.className = 'cu-mini-cart__item cu-mini-favorites__item'
    link.href = item.url
    imageWrap.className = 'cu-mini-cart__image'
    details.className = 'cu-mini-cart__details'
    title.textContent = item.title
    price.className = 'money'
    price.textContent = normalizeFavoritePrice(item.price)
    removeButton.type = 'button'
    removeButton.className = 'cu-mini-favorites__remove'
    removeButton.setAttribute('data-cu-favorite-remove', item.id)
    removeButton.setAttribute('aria-label', 'Remove ' + item.title + ' from favorites')
    removeButton.textContent = '×'

    if (item.image) {
      var image = document.createElement('img')
      image.src = item.image.indexOf('//') === 0 ? 'https:' + item.image : item.image
      image.alt = ''
      image.loading = 'lazy'
      imageWrap.appendChild(image)
    }

    details.append(title, price)
    link.append(imageWrap, details)
    row.append(link, removeButton)

    return row
  }

  function updateFavoriteInterface() {
    var favorites = readFavorites()
    var favoriteIds = favorites.map(function (item) {
      return String(item.id)
    })

    document.querySelectorAll('[data-cu-favorite-toggle]').forEach(function (button) {
      var isFavorite = favoriteIds.indexOf(String(button.getAttribute('data-cu-favorite-id'))) !== -1
      var title = button.getAttribute('data-cu-favorite-title') || 'this product'

      button.classList.toggle('is-active', isFavorite)
      button.setAttribute('aria-pressed', isFavorite ? 'true' : 'false')
      button.setAttribute(
        'aria-label',
        (isFavorite ? 'Remove ' : 'Add ') + title + (isFavorite ? ' from favorites' : ' to favorites')
      )
    })

    document.querySelectorAll('[data-cu-favorites-count]').forEach(function (count) {
      count.textContent = favorites.length
      count.hidden = favorites.length === 0
    })

    document.querySelectorAll('[data-cu-favorites-popover]').forEach(function (popover) {
      var items = popover.querySelector('[data-cu-favorites-items]')
      var empty = popover.querySelector('[data-cu-favorites-empty]')
      var footer = popover.querySelector('[data-cu-favorites-footer]')
      var total = popover.querySelector('[data-cu-favorites-total]')
      var footerCount = popover.querySelector('[data-cu-favorites-footer-count]')
      var isEmpty = favorites.length === 0

      if (!items || !empty || !footer || !total || !footerCount) {
        return
      }

      items.replaceChildren()
      favorites.slice(0, 5).forEach(function (item) {
        items.appendChild(createFavoritePreviewItem(item))
      })
      total.textContent = favorites.length
      footerCount.textContent = favorites.length
      items.hidden = isEmpty
      empty.hidden = !isEmpty
      footer.hidden = isEmpty
    })

    document.dispatchEvent(new CustomEvent('cu:favorites:updated', {
      detail: { favorites: favorites }
    }))
  }

  function toggleFavorite(button) {
    var product = productFromFavoriteButton(button)
    var favorites = readFavorites()
    var existingIndex = favorites.findIndex(function (item) {
      return String(item.id) === String(product.id)
    })

    if (existingIndex === -1) {
      favorites.unshift(product)
    } else {
      favorites.splice(existingIndex, 1)
    }

    writeFavorites(favorites)
    updateFavoriteInterface()
  }

  function removeFavorite(productId) {
    var favorites = readFavorites().filter(function (item) {
      return String(item.id) !== String(productId)
    })

    writeFavorites(favorites)
    updateFavoriteInterface()
  }

  function closeFavoritesMenus(exception) {
    document.querySelectorAll('.cu-favorites-menu.is-open').forEach(function (menu) {
      if (menu === exception) {
        return
      }

      menu.classList.remove('is-open')
      var trigger = menu.querySelector('[data-cu-favorites-trigger]')
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false')
      }
    })
  }

  function updateHorizontalNav(nav) {
    var track = nav.querySelector('[data-cu-horizontal-nav-track]')
    var previous = nav.querySelector('[data-cu-horizontal-nav-button="-1"]')
    var next = nav.querySelector('[data-cu-horizontal-nav-button="1"]')

    if (!track || !previous || !next) {
      return
    }

    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth)
    var hasOverflow = maxScroll > 4
    previous.hidden = !hasOverflow || track.scrollLeft <= 4
    next.hidden = !hasOverflow || track.scrollLeft >= maxScroll - 4
  }

  function initializeHorizontalNavs(scope) {
    var root = scope || document

    root.querySelectorAll('[data-cu-horizontal-nav]').forEach(function (nav) {
      if (nav.dataset.cuHorizontalNavReady === 'true') {
        updateHorizontalNav(nav)
        return
      }

      nav.dataset.cuHorizontalNavReady = 'true'
      var track = nav.querySelector('[data-cu-horizontal-nav-track]')

      if (!track) {
        return
      }

      var updateQueued = false
      var scheduleUpdate = function () {
        if (updateQueued) {
          return
        }

        updateQueued = true
        window.requestAnimationFrame(function () {
          updateQueued = false
          updateHorizontalNav(nav)
        })
      }

      nav.querySelectorAll('[data-cu-horizontal-nav-button]').forEach(function (button) {
        button.addEventListener('click', function () {
          var direction = parseInt(button.getAttribute('data-cu-horizontal-nav-button'), 10)
          var distance = Math.max(280, Math.round(track.clientWidth * 0.72))

          track.scrollBy({
            left: distance * direction,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          })
        })
      })

      track.addEventListener('scroll', scheduleUpdate, { passive: true })

      if (typeof window.ResizeObserver !== 'undefined') {
        var resizeObserver = new ResizeObserver(scheduleUpdate)
        resizeObserver.observe(track)
        nav.cuHorizontalResizeObserver = resizeObserver
      } else {
        window.addEventListener('resize', scheduleUpdate)
      }

      updateHorizontalNav(nav)
    })
  }

  function initializeMemoryStudios(scope) {
    var root = scope || document

    root.querySelectorAll('[data-cu-memory-motion]').forEach(function (studio) {
      if (studio.dataset.cuMemoryMotionReady === 'true') {
        return
      }

      var track = studio.querySelector('[data-cu-memory-track]')
      var sticky = studio.querySelector('[data-cu-memory-sticky]')
      var surface = studio.querySelector('[data-cu-memory-surface]')
      var base = studio.querySelector('.cu-memory-studio__base')
      var copy = studio.querySelector('[data-cu-memory-copy]')
      var badge = studio.querySelector('[data-cu-memory-badge]')
      var fragments = Array.prototype.slice.call(studio.querySelectorAll('[data-cu-memory-fragment]'))

      if (!track || !sticky || !surface || !base || !copy) {
        return
      }

      studio.dataset.cuMemoryMotionReady = 'true'

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        studio.classList.add('is-memory-static')
        return
      }

      studio.classList.add('is-memory-motion-ready')

      var updateQueued = false
      var clamp = function (value, minimum, maximum) {
        return Math.min(maximum, Math.max(minimum, value))
      }
      var easeOutCubic = function (value) {
        return 1 - Math.pow(1 - value, 3)
      }

      var updateMotion = function () {
        var trackRect = track.getBoundingClientRect()
        var stickyTop = parseFloat(window.getComputedStyle(sticky).top) || 0
        var travel = Math.max(1, track.offsetHeight - sticky.offsetHeight)
        var progress = clamp((stickyTop - trackRect.top) / travel, 0, 1)
        var isDesktop = window.matchMedia('(min-width: 769px)').matches
        var startScale = isDesktop ? 1.44 : 1.2
        var surfaceScale = startScale - ((startScale - 1) * progress)
        var surfaceShift = (1 - progress) * (isDesktop ? 24 : 12)
        var copyProgress = easeOutCubic(clamp((progress - 0.2) / 0.5, 0, 1))
        var cardProgress = easeOutCubic(clamp((progress - 0.16) / 0.68, 0, 1))
        var cardFade = 1 - clamp((progress - 0.84) / 0.14, 0, 1)
        var mediaWidth = Math.max(1, surface.offsetWidth)
        var mediaHeight = Math.max(1, surface.offsetHeight)
        var vectors = isDesktop
          ? [
              { x: -0.88, y: -0.72, scale: 1.62, rotate: -8 },
              { x: 0.92, y: -0.62, scale: 1.5, rotate: 7 },
              { x: -0.95, y: 0.74, scale: 1.58, rotate: 6 },
              { x: 0.98, y: 0.7, scale: 1.72, rotate: -7 }
            ]
          : [
              { x: -0.62, y: -0.52, scale: 1.34, rotate: -6 },
              { x: 0.64, y: -0.48, scale: 1.3, rotate: 5 },
              { x: -0.68, y: 0.54, scale: 1.32, rotate: 5 },
              { x: 0.7, y: 0.5, scale: 1.36, rotate: -5 }
            ]

        surface.style.transform = 'translate3d(0,' + surfaceShift.toFixed(2) + 'px,0) scale(' + surfaceScale.toFixed(4) + ')'
        base.style.opacity = (0.58 + (progress * 0.42)).toFixed(3)
        base.style.filter = 'saturate(' + (0.76 + (progress * 0.24)).toFixed(3) + ') blur(' + ((1 - progress) * 1.8).toFixed(2) + 'px)'
        copy.style.opacity = (0.16 + (copyProgress * 0.84)).toFixed(3)
        copy.style.transform = 'translate3d(0,' + ((1 - copyProgress) * 58).toFixed(2) + 'px,0) scale(' + (0.96 + (copyProgress * 0.04)).toFixed(4) + ')'

        if (badge) {
          var badgeProgress = easeOutCubic(clamp((progress - 0.62) / 0.25, 0, 1))
          badge.style.opacity = badgeProgress.toFixed(3)
          badge.style.transform = 'translate3d(0,' + ((1 - badgeProgress) * 24).toFixed(2) + 'px,0)'
        }

        fragments.forEach(function (fragment, index) {
          var vector = vectors[index] || vectors[0]
          var inverse = 1 - cardProgress
          var translateX = vector.x * mediaWidth * inverse
          var translateY = vector.y * mediaHeight * inverse
          var scale = 1 + ((vector.scale - 1) * inverse)
          var rotate = vector.rotate * inverse
          var opacity = clamp(cardProgress * 2.4, 0, 1) * cardFade

          fragment.style.opacity = opacity.toFixed(3)
          fragment.style.transform =
            'translate3d(' + translateX.toFixed(2) + 'px,' + translateY.toFixed(2) + 'px,0) ' +
            'scale(' + scale.toFixed(4) + ') rotate(' + rotate.toFixed(2) + 'deg)'
        })
      }

      var scheduleUpdate = function () {
        if (updateQueued) {
          return
        }

        updateQueued = true
        window.requestAnimationFrame(function () {
          updateQueued = false
          updateMotion()
        })
      }

      window.addEventListener('scroll', scheduleUpdate, { passive: true })
      window.addEventListener('resize', scheduleUpdate)
      updateMotion()
    })
  }

  function initializeCatalogFilters(scope) {
    var root = scope || document

    root.querySelectorAll('[data-cu-catalog-filter]').forEach(function (catalog) {
      if (catalog.dataset.cuCatalogFilterReady === 'true') {
        return
      }

      var cards = Array.prototype.slice.call(catalog.querySelectorAll('[data-cu-catalog-card]'))
      var panel = catalog.querySelector('[data-cu-catalog-filter-panel]')
      var trigger = catalog.querySelector('[data-cu-catalog-filter-toggle]')
      var resultCount = catalog.querySelector('[data-cu-catalog-result-count]')
      var activeCount = catalog.querySelector('[data-cu-catalog-active-count]')
      var emptyState = catalog.querySelector('[data-cu-catalog-empty]')
      var categoryOptions = catalog.querySelector('[data-cu-catalog-category-options]')
      var brandOptions = catalog.querySelector('[data-cu-catalog-brand-options]')
      var priceRange = catalog.querySelector('[data-cu-catalog-price-range]')
      var minSlider = catalog.querySelector('[data-cu-catalog-price-slider="min"]')
      var maxSlider = catalog.querySelector('[data-cu-catalog-price-slider="max"]')
      var minInput = catalog.querySelector('[data-cu-catalog-price-input="min"]')
      var maxInput = catalog.querySelector('[data-cu-catalog-price-input="max"]')
      var priceSummary = catalog.querySelector('[data-cu-catalog-price-summary]')

      if (
        !cards.length ||
        !panel ||
        !trigger ||
        !categoryOptions ||
        !brandOptions ||
        !priceRange ||
        !minSlider ||
        !maxSlider ||
        !minInput ||
        !maxInput
      ) {
        return
      }

      catalog.dataset.cuCatalogFilterReady = 'true'

      var mobileQuery = window.matchMedia('(max-width: 980px)')
      var categoryCounts = {}
      var brandCounts = {}
      var stockCounts = { in: 0, out: 0 }
      var priceMinimum = null
      var priceMaximum = 0
      var desktopPanelHidden = false
      var lastFocusedElement = null

      var cardData = cards.map(function (card) {
        var category = (card.dataset.cuCatalogCategory || 'Other').trim() || 'Other'
        var vendors = (card.dataset.cuCatalogVendors || '')
          .split('||')
          .map(function (vendor) {
            return vendor.trim()
          })
          .filter(Boolean)
        var stock = card.dataset.cuCatalogStock === 'out' ? 'out' : 'in'
        var minimum = parseInt(card.dataset.cuCatalogMinPrice, 10) || 0
        var maximum = parseInt(card.dataset.cuCatalogMaxPrice, 10) || minimum

        categoryCounts[category] = (categoryCounts[category] || 0) + 1
        stockCounts[stock] += 1

        vendors.forEach(function (vendor) {
          brandCounts[vendor] = (brandCounts[vendor] || 0) + 1
        })

        if (priceMinimum === null || minimum < priceMinimum) {
          priceMinimum = minimum
        }

        priceMaximum = Math.max(priceMaximum, maximum)

        return {
          element: card,
          category: category,
          vendors: vendors,
          stock: stock,
          minimum: minimum,
          maximum: maximum
        }
      })

      priceMinimum = priceMinimum === null ? 0 : priceMinimum
      priceMaximum = Math.max(priceMinimum, priceMaximum)

      var formatMoney = function (cents) {
        if (
          window.theme &&
          theme.Currency &&
          typeof theme.Currency.formatMoney === 'function' &&
          theme.settings
        ) {
          return theme.Currency.formatMoney(cents, theme.settings.moneyFormat)
        }

        return '$' + (cents / 100).toFixed(2)
      }

      var inputValueFromCents = function (cents) {
        var amount = cents / 100
        return Number.isInteger(amount) ? String(amount) : amount.toFixed(2)
      }

      var createOptions = function (container, counts, filterName) {
        var entries = Object.keys(counts).sort(function (first, second) {
          return first.localeCompare(second)
        })

        entries.forEach(function (entry, index) {
          var option = document.createElement('label')
          var input = document.createElement('input')
          var marker = document.createElement('span')
          var copy = document.createElement('span')

          option.className = 'cu-catalog-filter__option'
          if (index > 5) {
            option.classList.add('is-extra')
          }

          input.type = 'checkbox'
          input.value = entry
          input.setAttribute('data-cu-catalog-' + filterName + '-filter', '')
          marker.setAttribute('aria-hidden', 'true')
          copy.textContent = entry + ' (' + counts[entry] + ')'

          option.appendChild(input)
          option.appendChild(marker)
          option.appendChild(copy)
          container.appendChild(option)
        })

        if (entries.length > 6) {
          var moreButton = document.createElement('button')
          var group = container.closest('[data-cu-catalog-filter-group]')

          moreButton.className = 'cu-catalog-filter__more'
          moreButton.type = 'button'
          moreButton.textContent = 'Show ' + (entries.length - 6) + ' more'
          moreButton.addEventListener('click', function () {
            var willExpand = !group.classList.contains('is-showing-all')
            group.classList.toggle('is-showing-all', willExpand)
            moreButton.textContent = willExpand ? 'Show less' : 'Show ' + (entries.length - 6) + ' more'
          })
          container.appendChild(moreButton)
        }

        return entries.length
      }

      createOptions(categoryOptions, categoryCounts, 'category')
      var brandOptionCount = createOptions(brandOptions, brandCounts, 'brand')

      if (!brandOptionCount) {
        var brandGroup = brandOptions.closest('[data-cu-catalog-filter-group]')
        if (brandGroup) {
          brandGroup.hidden = true
        }
      }

      catalog.querySelectorAll('[data-cu-catalog-stock-count]').forEach(function (count) {
        var stock = count.getAttribute('data-cu-catalog-stock-count')
        count.textContent = stockCounts[stock]
      })

      catalog.querySelectorAll('[data-cu-catalog-stock-filter]').forEach(function (input) {
        input.disabled = stockCounts[input.value] === 0
      })

      var sliderMaximum = priceMaximum === priceMinimum ? priceMaximum + 1 : priceMaximum
      var sliderStep = 1

      ;[minSlider, maxSlider].forEach(function (slider) {
        slider.min = String(priceMinimum)
        slider.max = String(sliderMaximum)
        slider.step = String(sliderStep)
      })

      minSlider.value = String(priceMinimum)
      maxSlider.value = String(sliderMaximum)
      minInput.value = inputValueFromCents(priceMinimum)
      maxInput.value = inputValueFromCents(priceMaximum)
      minInput.min = inputValueFromCents(priceMinimum)
      minInput.max = inputValueFromCents(priceMaximum)
      maxInput.min = inputValueFromCents(priceMinimum)
      maxInput.max = inputValueFromCents(priceMaximum)

      var checkedValues = function (selector) {
        return Array.prototype.slice.call(catalog.querySelectorAll(selector + ':checked')).map(function (input) {
          return input.value
        })
      }

      var updatePriceDisplay = function () {
        var selectedMinimum = parseInt(minSlider.value, 10)
        var selectedMaximum = Math.min(priceMaximum, parseInt(maxSlider.value, 10))
        var availableRange = Math.max(1, sliderMaximum - priceMinimum)
        var start = ((selectedMinimum - priceMinimum) / availableRange) * 100
        var end = ((parseInt(maxSlider.value, 10) - priceMinimum) / availableRange) * 100

        priceRange.style.setProperty('--cu-price-start', start.toFixed(2) + '%')
        priceRange.style.setProperty('--cu-price-end', end.toFixed(2) + '%')
        minInput.value = inputValueFromCents(selectedMinimum)
        maxInput.value = inputValueFromCents(selectedMaximum)

        if (priceSummary) {
          priceSummary.innerHTML = formatMoney(selectedMinimum) + ' – ' + formatMoney(selectedMaximum)
        }

        minSlider.style.zIndex = selectedMinimum > selectedMaximum - (sliderStep * 3) ? '4' : '3'
      }

      var getActiveFilterCount = function () {
        var count =
          checkedValues('[data-cu-catalog-category-filter]').length +
          checkedValues('[data-cu-catalog-stock-filter]').length +
          checkedValues('[data-cu-catalog-brand-filter]').length

        if (
          parseInt(minSlider.value, 10) > priceMinimum ||
          parseInt(maxSlider.value, 10) < sliderMaximum
        ) {
          count += 1
        }

        return count
      }

      var applyFilters = function () {
        var categories = checkedValues('[data-cu-catalog-category-filter]')
        var stocks = checkedValues('[data-cu-catalog-stock-filter]')
        var brands = checkedValues('[data-cu-catalog-brand-filter]')
        var selectedMinimum = parseInt(minSlider.value, 10)
        var selectedMaximum = Math.min(priceMaximum, parseInt(maxSlider.value, 10))
        var visibleCount = 0

        cardData.forEach(function (item) {
          var categoryMatches = !categories.length || categories.indexOf(item.category) !== -1
          var stockMatches = !stocks.length || stocks.indexOf(item.stock) !== -1
          var brandMatches = !brands.length || item.vendors.some(function (vendor) {
            return brands.indexOf(vendor) !== -1
          })
          var priceMatches = item.maximum >= selectedMinimum && item.minimum <= selectedMaximum
          var matches = categoryMatches && stockMatches && brandMatches && priceMatches

          item.element.hidden = !matches
          if (matches) {
            visibleCount += 1
          }
        })

        var filterCount = getActiveFilterCount()

        if (resultCount) {
          resultCount.textContent = visibleCount
        }

        if (activeCount) {
          activeCount.hidden = filterCount === 0
          activeCount.textContent = filterCount
        }

        catalog.classList.toggle('is-filtered', filterCount > 0)

        if (emptyState) {
          emptyState.hidden = visibleCount !== 0
        }

        catalog.querySelectorAll('[data-cu-catalog-filter-clear]').forEach(function (button) {
          button.disabled = filterCount === 0
        })

        updatePriceDisplay()
      }

      var clearFilters = function () {
        catalog.querySelectorAll(
          '[data-cu-catalog-category-filter], [data-cu-catalog-stock-filter], [data-cu-catalog-brand-filter]'
        ).forEach(function (input) {
          input.checked = false
        })

        minSlider.value = String(priceMinimum)
        maxSlider.value = String(sliderMaximum)
        applyFilters()
      }

      var syncSliderFromNumberInput = function (input, slider, otherSlider, isMinimum) {
        var parsed = parseFloat(input.value)

        if (Number.isNaN(parsed)) {
          input.value = inputValueFromCents(parseInt(slider.value, 10))
          return
        }

        var cents = Math.round(parsed * 100)
        var lowerBoundary = isMinimum ? priceMinimum : parseInt(minSlider.value, 10)
        var upperBoundary = isMinimum ? parseInt(maxSlider.value, 10) : sliderMaximum
        slider.value = String(Math.min(upperBoundary, Math.max(lowerBoundary, cents)))
        applyFilters()
      }

      minSlider.addEventListener('input', function () {
        if (parseInt(minSlider.value, 10) > parseInt(maxSlider.value, 10)) {
          minSlider.value = maxSlider.value
        }
        applyFilters()
      })

      maxSlider.addEventListener('input', function () {
        if (parseInt(maxSlider.value, 10) < parseInt(minSlider.value, 10)) {
          maxSlider.value = minSlider.value
        }
        applyFilters()
      })

      minInput.addEventListener('change', function () {
        syncSliderFromNumberInput(minInput, minSlider, maxSlider, true)
      })

      maxInput.addEventListener('change', function () {
        syncSliderFromNumberInput(maxInput, maxSlider, minSlider, false)
      })

      minInput.addEventListener('input', function () {
        if (minInput.value.trim() !== '') {
          syncSliderFromNumberInput(minInput, minSlider, maxSlider, true)
        }
      })

      maxInput.addEventListener('input', function () {
        if (maxInput.value.trim() !== '') {
          syncSliderFromNumberInput(maxInput, maxSlider, minSlider, false)
        }
      })

      catalog.addEventListener('change', function (event) {
        if (
          event.target.matches(
            '[data-cu-catalog-category-filter], [data-cu-catalog-stock-filter], [data-cu-catalog-brand-filter]'
          )
        ) {
          applyFilters()
        }
      })

      catalog.querySelectorAll('[data-cu-catalog-filter-clear]').forEach(function (button) {
        button.addEventListener('click', clearFilters)
      })

      catalog.querySelectorAll('[data-cu-catalog-group-toggle]').forEach(function (button) {
        button.addEventListener('click', function () {
          button.setAttribute(
            'aria-expanded',
            button.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
          )
        })
      })

      var closeMobilePanel = function (restoreFocus) {
        catalog.classList.remove('is-filter-open')
        document.documentElement.classList.remove('cu-catalog-filter-open')
        trigger.setAttribute('aria-expanded', 'false')
        panel.setAttribute('aria-hidden', 'true')

        if (restoreFocus && lastFocusedElement) {
          lastFocusedElement.focus()
        }
      }

      var updatePanelMode = function () {
        if (mobileQuery.matches) {
          catalog.classList.remove('is-filter-panel-hidden')
          closeMobilePanel(false)
        } else {
          catalog.classList.remove('is-filter-open')
          document.documentElement.classList.remove('cu-catalog-filter-open')
          catalog.classList.toggle('is-filter-panel-hidden', desktopPanelHidden)
          trigger.setAttribute('aria-expanded', desktopPanelHidden ? 'false' : 'true')
          panel.removeAttribute('aria-hidden')
        }
      }

      trigger.addEventListener('click', function () {
        if (mobileQuery.matches) {
          lastFocusedElement = trigger
          catalog.classList.add('is-filter-open')
          document.documentElement.classList.add('cu-catalog-filter-open')
          trigger.setAttribute('aria-expanded', 'true')
          panel.setAttribute('aria-hidden', 'false')
          panel.querySelector('button, input').focus()
          return
        }

        desktopPanelHidden = !desktopPanelHidden
        updatePanelMode()
      })

      catalog.querySelectorAll('[data-cu-catalog-filter-close]').forEach(function (button) {
        button.addEventListener('click', function () {
          closeMobilePanel(true)
        })
      })

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && catalog.classList.contains('is-filter-open')) {
          closeMobilePanel(true)
        }
      })

      if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', updatePanelMode)
      } else {
        mobileQuery.addListener(updatePanelMode)
      }

      updatePanelMode()
      applyFilters()
    })
  }

  function initializeScrollCenter(scope) {
    var root = scope || document

    root.querySelectorAll('[data-cu-scroll-center]').forEach(function (element) {
      if (element.dataset.cuScrollCenterReady === 'true') {
        return
      }

      element.dataset.cuScrollCenterReady = 'true'

      if (
        typeof window.IntersectionObserver === 'undefined' ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        element.classList.add('is-centered')
        return
      }

      var observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) {
          return
        }

        element.classList.add('is-centered')
        observer.disconnect()
      }, {
        threshold: 0.35,
        rootMargin: '0px 0px -8% 0px'
      })

      observer.observe(element)
    })
  }

  function getPersonalizationCartSidebar() {
    return Array.prototype.find.call(
      document.querySelectorAll('[class*="__add-cart-success-"]:not([class*="__add-cart-success-modal-"])'),
      function (sidebar) {
        var styles = window.getComputedStyle(sidebar)

        return sidebar.getClientRects().length > 0 &&
          styles.position === 'fixed' &&
          styles.visibility !== 'hidden'
      }
    )
  }

  var personalizationCartPointerDismissed = false
  var personalizationCartResetTimer = null

  function closePersonalizationCartSidebar(sidebar) {
    var continueShopping = sidebar.querySelector('.__button_ghost, [class*="__ghost-"]')

    if (!continueShopping) {
      return false
    }

    continueShopping.click()
    return true
  }

  window.addEventListener('pointerdown', function (event) {
    var sidebar = getPersonalizationCartSidebar()

    if (!sidebar || sidebar.contains(event.target)) {
      return
    }

    personalizationCartPointerDismissed = closePersonalizationCartSidebar(sidebar)

    if (!personalizationCartPointerDismissed) {
      return
    }

    window.clearTimeout(personalizationCartResetTimer)
    personalizationCartResetTimer = window.setTimeout(function () {
      personalizationCartPointerDismissed = false
    }, 1200)

    event.preventDefault()
    event.stopImmediatePropagation()
  }, true)

  window.addEventListener('click', function (event) {
    var sidebar = getPersonalizationCartSidebar()

    if (sidebar && sidebar.contains(event.target)) {
      return
    }

    if (!sidebar && !personalizationCartPointerDismissed) {
      return
    }

    event.preventDefault()
    event.stopImmediatePropagation()

    if (sidebar) {
      closePersonalizationCartSidebar(sidebar)
    }

    personalizationCartPointerDismissed = false
    window.clearTimeout(personalizationCartResetTimer)
  }, true)

  document.addEventListener('click', function (event) {
    var removeButton = event.target.closest('[data-cu-favorite-remove]')

    if (removeButton) {
      event.preventDefault()
      removeFavorite(removeButton.getAttribute('data-cu-favorite-remove'))
      return
    }

    var favoriteButton = event.target.closest('[data-cu-favorite-toggle]')

    if (favoriteButton) {
      event.preventDefault()
      toggleFavorite(favoriteButton)
      return
    }

    var favoritesTrigger = event.target.closest('[data-cu-favorites-trigger]')

    if (favoritesTrigger) {
      var menu = favoritesTrigger.closest('.cu-favorites-menu')
      var willOpen = !menu.classList.contains('is-open')

      closeFavoritesMenus(menu)
      menu.classList.toggle('is-open', willOpen)
      favoritesTrigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false')
      return
    }

    if (!event.target.closest('.cu-favorites-menu')) {
      closeFavoritesMenus()
    }
  })

  document.addEventListener('click', function (event) {
    var galleryButton = event.target.closest('[data-cu-gallery-direction]')

    if (!galleryButton) {
      return
    }

    var productImages = galleryButton.closest('product-images')

    if (!productImages || !productImages.flickity || !productImages.settings) {
      return
    }

    var slides = productImages.querySelectorAll('.product-main-slide:not(.hide)')
    var direction = parseInt(galleryButton.getAttribute('data-cu-gallery-direction'), 10)
    var currentIndex = parseInt(productImages.settings.currentSlideIndex, 10) || 0
    var nextIndex = (currentIndex + direction + slides.length) % slides.length

    productImages.flickity.goToSlide(nextIndex)
  })

  window.addEventListener('storage', function (event) {
    if (event.key === favoritesKey) {
      updateFavoriteInterface()
    }
  })

  document.addEventListener('collection-component:loaded', updateFavoriteInterface)

  document.addEventListener('click', function (event) {
    var closeButton = event.target.closest('[data-cu-announcement-close]')

    if (!closeButton) {
      return
    }

    var announcement = closeButton.closest('[data-cu-announcement]')

    if (!announcement) {
      return
    }

    rememberDismissal()
    hideAnnouncement(announcement)
  })

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.cu-menu-details')) {
      document.querySelectorAll('.cu-menu-details[open]').forEach(function (details) {
        details.open = false
      })
    }
  })

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') {
      return
    }

    document.querySelectorAll('.cu-menu-details[open]').forEach(function (details) {
      details.open = false
    })
    closeFavoritesMenus()
  })

  document.addEventListener('DOMContentLoaded', function () {
    initializeAnnouncement()
    initializeMegaMenus(document)
    initializeHeaderSearchTabs(document)
    initializeProcessShowcases(document)
    updateFavoriteInterface()
    initializeHorizontalNavs(document)
    initializeMemoryStudios(document)
    initializeScrollCenter(document)
  })

  document.addEventListener('shopify:section:load', function (event) {
    initializeAnnouncement()
    initializeMegaMenus(event.target)
    initializeHeaderSearchTabs(event.target)
    initializeProcessShowcases(event.target)
    updateFavoriteInterface()
    initializeHorizontalNavs(event.target)
    initializeMemoryStudios(event.target)
    initializeScrollCenter(event.target)
  })
})()
